import { useTranslation } from 'react-i18next'

import { formatMinutesToHours } from '@percent/workplace-giving/utils/dayjs/dayjs'
import { DashboardMetricCard } from '@percent/workplace-giving/common/components/DashboardMetricCard/DashboardMetricCard'
import { useQuery } from '@percent/workplace-giving/common/hooks'
import { useVolunteeringAllowancePeriod } from '@percent/workplace-giving/common/hooks/useVolunteeringAllowancePeriod/useVolunteeringAllowancePeriod'
import { getAccountBudget } from '@percent/workplace-giving/api/opportunity/getAccountBudget/getAccountBudget'
import { AppRoute } from '@percent/workplace-giving/routing/AppRoute.enum'

export function TotalVolunteeredCard(): JSX.Element {
  const { t } = useTranslation()
  const { translationKey: allowancePeriodKey } = useVolunteeringAllowancePeriod()

  const { data, isLoading } = useQuery(['getAccountBudget', {}], getAccountBudget, {
    staleTime: 1000 * 20
  })

  const hasAllowance = data?.budget?.allowanceMinutes && data?.budget?.allowanceMinutes > 0
  const minutes = hasAllowance ? data?.budget?.usedMinutes : data?.totalMinutes

  const formattedTime =
    !isLoading && minutes && minutes > 0 ? formatMinutesToHours(minutes, t) : `0 ${t('workplace_giving.common.hours')}`

  const hours = minutes ? Math.floor(minutes / 60) : 0
  const compactTime = minutes && minutes > 0 ? `${hours}${t('workplace_giving.timeFormatting.hoursAbbrev')}` : undefined

  const description = t(
    hasAllowance ? allowancePeriodKey : 'workplace_giving.volunteering.lifetimeVolunteeredSentenceCase.title'
  )

  return (
    <DashboardMetricCard
      title={t('workplace_giving.volunteering.totalVolunteered.title')}
      value={formattedTime}
      compactValue={compactTime}
      isLoading={isLoading}
      icon="stopwatch-outline"
      description={description}
      testId="total-volunteered-card"
      href={AppRoute.VOLUNTEER}
    />
  )
}
